class Inputmask {
    constructor() {
        let elements = document.querySelectorAll('[data-inputmask]');

        if (elements.length) {
            import('inputmask').then(mask => {
                Inputmask.extendInputMaskDefaultDefinitions(mask);
                mask().mask(elements);
            });
        }
    }
    static extendInputMaskDefaultDefinitions(inputmask) {
        inputmask.extendDefinitions({
            // Workspace url.
            'X': {
                validator: "[A-Za-z0-9-]",
                casing: "lower"
            }
        });
    }
}

module.exports = new Inputmask();
